import { render, staticRenderFns } from "./EmtaRegistration.vue?vue&type=template&id=5338bd04&scoped=true"
import script from "./EmtaRegistration.vue?vue&type=script&lang=js"
export * from "./EmtaRegistration.vue?vue&type=script&lang=js"
import style0 from "./EmtaRegistration.vue?vue&type=style&index=0&id=5338bd04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5338bd04",
  null
  
)

export default component.exports